module.exports = __webpack_public_path__ + "static/media/arrow_down_red.8e6d1248.svg";